import {
  getItemTypePlural,
  getItemCategoryPlural,
} from '../../config/constants';

const itemTypePluralize = (item, realType) => {
  const ret = getItemTypePlural(item, realType);
  return ret;
};

export function categoryPluralize(item) {
  const ret = getItemCategoryPlural(item);
  return ret;
}

export default itemTypePluralize;


// WEBPACK FOOTER //
// ./src/components/common/itemTypePluralrize.js